module.exports = __webpack_public_path__ + "media/images/story/top/capture_about-09fb6139922af40e61d33c585b37b3fe.svg";